import { ActionTree } from 'vuex'
import auth0 from 'auth0-js'
import axios from 'axios'

import _get from 'lodash/get'

import { BASE_URL } from '@/config'
import { AuthState } from './types'
import { RootState } from '../types'

const CLIENT_ID = process.env.VUE_APP_AUTH0_CLIENT_ID
const CLIENT_DOMAIN = process.env.VUE_APP_AUTH0_DOMAIN
const REDIRECT = 'callback'
const AUDIENCE = process.env.VUE_APP_AUTH0_CLIENT_AUDIENCE
const REDIRECT_TO =
  process.env.NODE_ENV === 'production'
    ? `https://${window.location.hostname}`
    : process.env.VUE_APP_REDIRECT_TO

const auth = new auth0.WebAuth({
  clientID: CLIENT_ID,
  domain: CLIENT_DOMAIN,
})

export const actions: ActionTree<AuthState, RootState> = {
  login({ commit, state }): any {
    commit('auth/reset', null, { root: true })
    commit('books/reset', null, { root: true })
    commit('offers/reset', null, { root: true })
    commit('offerCarts/reset', null, { root: true })
    commit('sellers/reset', null, { root: true })
    commit('setRequestLogin')

    const port = window.location.port ? `:${window.location.port}` : ''
    auth.authorize({
      responseType: 'token id_token',
      scope: 'openid email profile',
      redirectUri: `${location.protocol}//${location.hostname}${port}/${REDIRECT}`,
      audience: AUDIENCE,
    })
  },
  logout({ commit }): any {
    commit('auth/reset', null, { root: true })
    commit('books/reset', null, { root: true })
    commit('offers/reset', null, { root: true })
    commit('offerCarts/reset', null, { root: true })
    commit('sellers/reset', null, { root: true })

    auth.logout({
      domain: CLIENT_DOMAIN,
      returnTo: REDIRECT_TO,
    })
  },
  setAuthentication({ commit }) {
    commit('setAuthentication', {
      idToken: getParameterByName('id_token'),
      accessToken: getParameterByName('access_token'),
    })
  },
  getUserInfoByAuth0Id({ commit, getters }, auth0Id: string) {
    commit('auth/resetRequest', null, { root: true })
    commit('books/reset', null, { root: true })
    commit('offers/reset', null, { root: true })
    commit('offerCarts/reset', null, { root: true })
    commit('sellers/reset', null, { root: true })

    const path = `${BASE_URL}/user/auth0`
    const params = {
      auth0Id,
    }
    commit('setRequestGetUserInfo', true)
    return axios
      .get(path, {
        params,
      })
      .then(response => {
        commit('setUserInfo', _get(response, 'data') || null)
        // const tempActiveOffer = _get(response, ['data', 'activeOffer']) || null;
        // commit('offerCarts/setActiveOffer', { offer: tempActiveOffer }, {root: true} );
        return response
      })
      .catch(err => {
        throw err
      })
  },
}

const getParameterByName = name => {
  const match = RegExp('[#&]' + name + '=([^&]*)').exec(window.location.hash)
  return (match && decodeURIComponent(match[1].replace(/\+/g, ' '))) || ''
}
